/**
 * Interview CMS content type (design spec P.17)
 *
 * Required: 氏名 / ローマ字 / slug / 職種 / キーワードタグ / 入社年 / 所属 /
 * 前職 / 技術スタック（入社時・現在） / 資格（入社時・現在） / キャッチコピー /
 * Q&A×6 / 画像 / 関連求人
 *
 * Skill Growth is optional until follow-up interviews are complete.
 */
export const INTERVIEW_JOBS = [
  { id: 'engineer', label: '開発エンジニア', tag: 'Engineer' },
  { id: 'infra', label: 'インフラエンジニア', tag: 'Infra' },
  { id: 'dx', label: 'DXエンジニア', tag: 'DX' },
  { id: 'sales', label: '営業', tag: 'Sales' },
  { id: 'corporate', label: 'コーポレート', tag: 'Corporate' },
  { id: 'newgrad', label: '新卒・インターン', tag: 'Newgrad' }
];

export const INTERVIEW_KEYWORDS = [
  { id: 'inexperienced', label: '未経験入社' },
  { id: 'career-change', label: '異業種からの転職' },
  { id: 'second-grad', label: '第二新卒' },
  { id: 'remote', label: 'リモート／地方在住' },
  { id: 'parenting', label: '育児と両立' },
  { id: 'management', label: 'マネジメント' },
  { id: 'certification', label: '資格取得支援' }
];

export const DEFAULT_INTERVIEW_QA = [
  { id: 'work', num: '01', heading: '現在の仕事', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' },
  { id: 'career', num: '02', heading: '入社前のキャリア', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' },
  { id: 'join', num: '03', heading: '入社のきっかけ', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' },
  { id: 'gap', num: '04', heading: '入社後の変化', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' },
  { id: 'appeal', num: '05', heading: 'FLARETECHで働く魅力', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' },
  { id: 'message', num: '06', heading: '応募を考えている方へ', lead: '', body: '', extraLead: '', extraBody: '', image: '', pullQuote: '' }
];

export const JOB_DETAIL_PATHS = {
  engineer: '/jobs/development-engineer',
  infra: '/jobs/infrastructure-engineer',
  dx: '/jobs/dx-engineer',
  sales: '/jobs/sales'
};

export const INTERVIEW_REQUIRED_FIELDS = [
  'slug',
  'nameJa',
  'nameEn',
  'job',
  'thumbnail',
  'status'
];

export const interviewSchema = {
  slug: 'string',
  nameJa: 'string',
  nameEn: 'string',
  department: 'string',
  job: 'string',
  jobLabel: 'string',
  jobTagEn: 'string',
  joinYear: 'number',
  joinMeta: 'string',
  previousJob: 'string',
  keywords: 'array<string>',
  catchCopy: 'string',
  quote: 'string',
  oneLiner: 'string',
  thumbnail: 'string',
  heroImage: 'string',
  heroObjectPosition: 'string',
  profileImage: 'string',
  hasArticle: 'boolean',
  featuredOnHome: 'boolean',
  status: 'string',
  order: 'number',
  techStack: 'array<string>',
  techStackAtJoin: 'array<string>',
  certifications: 'array<string>',
  certificationsAtJoin: 'array<string>',
  qa: 'array<object>',
  photos: 'array<string>',
  skillGrowth: 'object',
  relatedJobPath: 'string',
  noteUrl: 'string',
  metaTitle: 'string',
  metaDescription: 'string'
};

export const suggestInterviewSlug = (nameEn = '') =>
  nameEn
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const createEmptyInterview = () => ({
  slug: '',
  nameJa: '',
  nameEn: '',
  department: '',
  job: 'engineer',
  jobLabel: '開発エンジニア',
  jobTagEn: 'Engineer',
  joinYear: null,
  joinMeta: '',
  previousJob: '',
  keywords: [],
  catchCopy: '',
  quote: '',
  oneLiner: '',
  thumbnail: '',
  heroImage: '',
  heroObjectPosition: '',
  profileImage: '',
  hasArticle: true,
  featuredOnHome: true,
  status: 'draft',
  order: 0,
  techStack: [],
  techStackAtJoin: [],
  certifications: [],
  certificationsAtJoin: [],
  qa: DEFAULT_INTERVIEW_QA.map((item) => ({ ...item })),
  photos: [],
  skillGrowth: null,
  relatedJobPath: '/jobs/development-engineer',
  noteUrl: '',
  metaTitle: '',
  metaDescription: ''
});

